import { useDispatch } from "react-redux";
import { ToastProps } from "../models/ToastProps";
import { markErrorRemoving } from "../../../../../../core/errors/errorSlice";
import ToastError from "../toastError/ToastError";
import ToastPermission from "../toastPermission/ToastPermission";
import ToastSuccess from "../toastSuccess/ToastSuccess";
import ToastWarning from "../toastWarning/ToastWarning";

const ToastListError = ({
	list = [],
	closeAction,
}: {
	list: ToastProps[];
	closeAction?: (id?: number) => void;
}) => {
	const dispatch = useDispatch();

	const handleClose = (id?: number) => {
		if (id) {
			dispatch(markErrorRemoving(id));
			setTimeout(() => {
				closeAction && closeAction(id);
			}, 300); // Match animation duration
		}
	};

	const renderToast = (toast: ToastProps) => {
		const className = toast.removing ? "toast-fade-out" : "";

		switch (toast.type) {
			case "success":
				return (
					<div
						key={toast.id}
						className={className}
					>
						<ToastSuccess
							{...toast}
							closeAction={() => handleClose(toast.id)}
						/>
					</div>
				);
			case "warning":
				return (
					<div
						key={toast.id}
						className={className}
					>
						<ToastWarning
							{...toast}
							closeAction={() => handleClose(toast.id)}
						/>
					</div>
				);
			case "error":
				return (
					<div
						key={toast.id}
						className={className}
					>
						<ToastError
							{...toast}
							closeAction={() => handleClose(toast.id)}
						/>
					</div>
				);
			case "unauthorized":
				return (
					<div
						key={toast.id}
						className={className}
					>
						<ToastPermission
							{...toast}
							closeAction={() => handleClose(toast.id)}
						/>
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<>
			<div className="shared-toastListError">
				{list.map((toast) => renderToast(toast))}
			</div>
		</>
	);
};

export default ToastListError;
